<template>
  <NavigationLinkWrapper :to="props.to" v-bind="$attrs" :disabled="props.disabled">
    <NavigationButtonContent
      :disabled="props.disabled"
      :icon="props.icon"
      :title="props.title"
      :subtitle="props.subtitle"
      :tooltip-text="props.tooltipText"
    />
  </NavigationLinkWrapper>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from "vue-router";

import { Icon } from "../assets/icons/Icon";
import NavigationButtonContent from "../components/NavigationButtonContent.vue";
import NavigationLinkWrapper from "./NavigationLinkWrapper.vue";

const props = defineProps<{
  to: RouteLocationRaw | string;
  icon?: Icon;
  title?: string;
  subtitle?: string;
  disabled?: boolean;
  tooltipText?: string;
}>();

defineSlots<{
  [key: string]: unknown;
}>();
</script>
